import { connect } from 'react-redux'
import { state_update } from '../actions'
import AiImageBig from './AiImageBig'
import imageLogic from '../reducers/imageLogic'

function getViews (state,cur_image_url){
  let slide_init=[]
  var max_views2 =state['max_view']
  var lsbefore =state['lsbefore']
  var lsafter =state['lsafter']
  var ls_image_url = cur_image_url.replace('sku='+state.sku,'sku='+state.style)

  if (lsbefore == undefined)
    lsbefore = 0
  if (lsafter == undefined)
    lsafter = 0

  if ( state.chain ==='-1' && state.style==='9000')
   max_views2 = 1

  for (let i=1;i<=lsbefore;i++) {
    slide_init.push(ls_image_url+'&view=l'+i.toString()) 
  }  

  for (let i=1;i<=max_views2;i++) {
    let extra_label = ''
    if (state.hasOwnProperty('extra_label_view_' + i.toString()) ){
      extra_label='&extra='+state['extra_label_view_' + i.toString()]
    }
    slide_init.push(cur_image_url+'&view='+i.toString()+ extra_label) 
  }

  for (let i=1;i<=lsafter;i++) {
    slide_init.push(ls_image_url+'&view=r'+i.toString()) 
  }  

  return slide_init   
}
function getViewIds (state){
  let view_init=[]
  var max_views2 =state['max_view']
  var lsbefore =state['lsbefore']
  var lsafter =state['lsafter']

  if (lsbefore == undefined)
    lsbefore = 0
  if (lsafter == undefined)
    lsafter = 0

  if ( state.chain ==='-1' && state.style==='9000')
   max_views2 = 1

  for (let i=1;i<=lsbefore;i++) {
    view_init.push('l'+i.toString()) 
  }  

  for (let i=1;i<=max_views2;i++) {
    view_init.push(i.toString()) 
  }

  for (let i=1;i<=lsafter;i++) {
    view_init.push('r'+i.toString()) 
  }  

  return view_init    
}
const mapStateToProps = (state, ownProps) => { 
  //let cur_image_url
  //let sku
  var clistqty= 0
  let cur_image_url =imageLogic(state);
  if (['9000'].includes(state.sku)){
  if (state['clist']!=='-1')
    clistqty+= (state['clist']).split('_').length
//    console.log('clistqty1',clistqty)
  if (state['acharm'] !=='-1' && state['acat'] !=='-1' )
     if (state['acat'] !=='2' || (state['acat'] ==='2' && state['e1']!=='' && state['s']==='9000') || (state['acat'] ==='2' && state['s'] !=='9000') )
         clistqty+=1
  }  
// console.log('clistqty200',state)
  return {
    max_views: state['max_view'],
    lsbefore: state['lsbefore'],
    lsafter: state['lsafter'],
    lifeshown: state['lifeshown'],
    lifestyle: state['start_over_init']['lifestyle'],
    style: state['style'],
    
    no_show_del: state.sku==='9000' && state.active_view!==1,
    active_view: state['active_view'] -1 ,
    view_image_base: cur_image_url,
    slides:getViews(state,cur_image_url),
    viewids:getViewIds(state),
    orientation:ownProps.orientation,
    pushOpenBox:state.pushOpenBox === true ? true :false,
    clistqty: clistqty,
    altered:state.altered
    
  }
}

 

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: ( (value) => {
    //console.log('new active view',value)
    dispatch(state_update({attr:'active_view',value:(value[0]+1)}))
    dispatch(state_update({attr:'active_image_url',value:(value[1][value[0]])}))
  }),
  onUpdate: ( (value) => {
    //console.log('new active view',value)
    //dispatch(state_update({attr:'active_view',value:(value[0]+1)}))
    dispatch(state_update({attr:'active_image_url',value:(value[1][value[0]])}))
  }),
  onLife: ( (value) => {
    //console.log('new active view',value)
    dispatch(state_update({attr:'lifeshown',value:('yes')}))
  }),
  onCloseOpenBox: ( () => {
      //console.log('close OpenBox')
      dispatch(state_update({attr:'pushOpenBox',value:false}))
    }),
  onOpenOpenBox: ( () => {
      //console.log('close OpenBox')
      dispatch(state_update({attr:'pushOpenBox',value:true}))
    }),
 onDel: ( (val) => {
     // console.log('onDEl Event',val,val['value'])
      dispatch(state_update({attr:'delcharm',value:val}))
    })
 
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiImageBig)


// WEBPACK FOOTER //
// ./src/layout/AiImageBigWrap.js